"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEval = void 0;
const user_eval_schema_1 = require("./user-eval.schema");
const base_model_1 = require("../../base-model");
class UserEval extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return user_eval_schema_1.userEvalSchema;
    }
}
exports.UserEval = UserEval;
